import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=5d246519&scoped=true"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=5d246519&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d246519"]])

export default __exports__